import { render } from "./_query.html?vue&type=template&id=2e9215c6&ts=true"
import script from "./_query.vue?vue&type=script&lang=ts"
export * from "./_query.vue?vue&type=script&lang=ts"

import "./_query.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__